// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"764efb27","508":"c6557286","776":"ef06fb58"}[chunkId] + ".chunk.js";
};